<template>
  <b-pagination
    ref="pagination"
    v-if="hasPagination && value > 0"
    v-model="value"
    :limit="limit"
    :align="align"
    :per-page="perPage"
    :total-rows="total"
    :disabled="loading"
    class="custom-pagination"
    :hide-goto-end-buttons="true"
    :hide-goto-start-buttons="true"
    @change="setPage"
  >
    <b-img
      slot="next-text"
      :src="require('@/assets/icons/arrow-right.svg')"
    ></b-img>
    <b-img
      slot="prev-text"
      :src="require('@/assets/icons/arrow-left.svg')"
    ></b-img>
  </b-pagination>
</template>
<script>
/**
 * ==================================================================================
 * Custom Pagination
 * ==================================================================================
 **/

export default {
  props: {
    meta: {
      type: Object
    },
    limit: {
      type: Number,
      default: 4
    },
    align: {
      type: String,
      default: 'center'
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    hasPagination() {
      return this.meta && this.meta.last_page > 1
    }
  },
  watch: {
    meta(value) {
      this.init()
    }
  },
  data: function() {
    return {
      value: 0,
      perPage: null,
      total: null
    }
  },
  methods: {
    init() {
      if (this.meta) {
        // if (this.meta.current_page && this.value !== this.meta.current_page) {
        this.value = this.meta.current_page
        // }

        // if (this.meta.per_page && this.perPage !== this.meta.per_page) {
        this.perPage = this.meta.per_page
        // }

        // if (this.meta.total && this.total !== this.meta.total) {
        this.total = this.meta.total
        // }
      }
    },

    setPage(page) {
      if (this.loading) return
      this.$emit('input', page)
      this.$emit('change', page)
    }
  },

  mounted() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
.custom-pagination /deep/ {
  align-items: center;

  .page-link:focus {
    box-shadow: none;
  }

  .page-item:first-child,
  .page-item:last-child {
    .page-link {
      padding: 0.5rem;
      border: 1px solid #6c6c6c;
      border-radius: 4px;
      cursor: pointer;

      img {
        width: 22.5px;
      }
    }
  }

  .page-item:first-child {
    .page-link {
      margin-right: 0.75rem;
    }
  }

  .page-item:last-child {
    .page-link {
      margin-left: 0.75rem;
    }
  }

  .page-item:not(:first-child):not(:last-child) {
    .page-link {
      font-size: 1.25rem;
      font-weight: 700;
      padding: 0.5rem 1rem;
      border: none;
      background: transparent;
      color: #b5b5b5;
    }
  }

  .page-item:not(:first-child):not(:last-child).active {
    .page-link {
      color: #1c1c1c;
    }
  }

  .page-item:first-child.disabled,
  .page-item:last-child.disabled {
    .page-link {
      opacity: 0.5;
    }
  }
}
</style>
